module.exports = __webpack_public_path__ + "img/industry.8116e15e.png";